import axios from 'axios';

export { getRecommendedOffers, getCustomerSpotOffers, getOffers, createOffer, editOffer };

async function getRecommendedOffers(basketRecommendationsQuery) {
  const response = await axios.get("/api/offers/recommended", { params: basketRecommendationsQuery });
  return response.data;
}

async function getCustomerSpotOffers(sellerAccountId, buyerAccountId) {
  const query = {
    sellerAccountIds: [sellerAccountId],
    platform: "OLFUK",
    buyerAccountId,
    includeAuditTrail: true,
    queryType: "EX",
  };
  try {
    const response = await axios.get("/api/offers/recommended", { params: query });
    return response.data.body;
  } catch (ex) {
    return [];
  }
}

async function createOffer(offerToSend) {
  try {
    const res = await axios.post("/api/createOffer", offerToSend);
    return res.data.offer;
  } catch (ex) {
    console.log(ex);
  }
}

async function editOffer(params) {
  try {
    const res = await axios.put("/api/editOfferDetails", { params });
    return res.data.body;
  } catch (ex) {
    console.log(ex);
  }
}

async function getOffers(query = { includeAuditTrail: true }) {
  try {
    const {
      data: { offers, haulageOffers },
    } = await axios.get("/api/v2/offers", { params: query });
    return { offers, haulageOffers };
  } catch (ex) {
    return [];
  }
}